import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { DatasourceList } from '../../datasource/components/DatasourceList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejDatasourceListPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='DatasetDatasources'
          action='update'
        >
          <DatasourceList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejDatasourceListPage;
